import { Box, Button, ThemeProvider } from '@mui/material'
import Header from '../../components/Header'

import React from "react"
import { useState } from "react"
import { useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

import * as Constants from '../../constants'

const DelLivestream = () => {
  let theme = useTheme()

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })

  const id = useParams().id
  const navigate = useNavigate()

  const handleSubmit = () => {
    fetch(Constants.HOST + '/deleteLivestream', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        livestream_id: id,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.success === false && data.message !== undefined) {
              setError({ error: true, message: data.message })
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: false, message: '' })
              setSuccess({ success: true, message: data.message })
              navigate('/livestreams')
            }
          })
        }
      })
      .catch((error) => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }

  return (
    <Box m="20px">
      <Header
        title="Excluir livestream"
      />
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1, display: 'flex' }}>
          <Button
            variant="outlined, contained"
            sx={{ marginLeft: '10px', bgcolor: 'green' }}
            onClick={() => navigate('/livestreams')}
          >
            Cancelar
          </Button>
          <Button
            variant="outlined, contained"
            sx={{ marginLeft: '10px', bgcolor: 'red' }}
            onClick={handleSubmit}
          >
            Excluir
          </Button>
        </Box>
      </ThemeProvider>
    </Box>
  )
}

export default DelLivestream
